import { createFileRoute, redirect } from '@tanstack/react-router'
import * as React from 'react'
import { resolveSession } from '../features/auth/session'
import { canSeeLicences, LicencesScreen, type LicencesSearch, parseLicencesSearch } from '../features/licences'

export const Route = createFileRoute('/licences')({
  validateSearch: (raw: Record<string, unknown>): LicencesSearch => parseLicencesSearch(raw),
  // Manager and billing only (the API's BillingActorDep). Cover and tech are sent home; the API 403s them regardless.
  // An unknown session (API unreachable) is not a role, so it is not redirected: the screen shows what failed instead.
  beforeLoad: async ({ context }) => {
    const session = await resolveSession(context.queryClient)
    if (session.kind === 'signed_in' && !canSeeLicences(session.me.role)) throw redirect({ to: '/' })
  },
  component: function LicencesRoute() {
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const onSearch = React.useCallback(
      (patch: Partial<LicencesSearch>) =>
        void navigate({ search: (prev: LicencesSearch) => parseLicencesSearch({ ...prev, ...patch }), replace: true }),
      [navigate],
    )
    return <LicencesScreen search={search} onSearch={onSearch} />
  },
})
